import React, { useEffect } from "react";
import { Container, Grid } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  UiButton,
  UiTextIconButton,
} from "../../_uiComponents/common/UiButton";
import TryAgainImage from "../../../styles/img/onboard/went-wrong.png";
import { hideError } from "../../../_redux/_actions";
import {
  onboardingClearFormData,
  onboardingClearFormResponseData,
  onboardingTryAgainFlow,
} from "../../../_redux/_actions/onboarding.actions";
import { onboardingConstants } from "../../../_redux/_constants";

export const ErrorPage = (props) => {
  const { t, i18n } = useTranslation();
  const naviagate = useNavigate();
  const dispatch = useDispatch();

  const goToBeginning = () => {
    dispatch(onboardingTryAgainFlow());
    dispatch(onboardingClearFormResponseData());
    dispatch(hideError());
    if (typeof props?.changeFlowStep === "function") {
      props.changeFlowStep(onboardingConstants.NIC_PASSPORT_VALIDATION_STEP);
    }
  };

  const goToLogin = () => {
    dispatch(onboardingClearFormData());
    dispatch(onboardingClearFormResponseData());
    dispatch(hideError());
    naviagate("/");
  };

  return (
    <>
      <div className="df-user-profile df-onboard-progress-back-close df-profile-top-aligned-box">
        <Container maxWidth="md" className="df-pos-rel">
          <div className="df-user-profile__body df-pw-tab">
            <Grid container className="df-align-center">
              <Grid size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}>
                <img src={TryAgainImage} className="df-verify-progress-img" />
              </Grid>

              <Grid
                size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}
                className="text-center"
              >
                <div className="df-onboard-radio df-onboard-nic-wr df-verify-progress">
                  <h4>
                    {<Trans i18nKey={t("Uh-oh! Something went wrong")} />}
                  </h4>
                  <p>
                    {t(
                      "We apologise for the inconvenience. It seems like there was an error or timeout during the registration process.",
                    )}
                  </p>

                  <UiTextIconButton
                    name={t("Try Again")}
                    onClick={goToBeginning}
                    className="df-primary-underlined-text-icon-btn df-onboard-try-again"
                  />

                  <div className="d-block mt-2">
                    <UiButton
                      className="df-ui-dark-bg-btn w-100 df-onboard-radio-btn"
                      name={t("Ok")}
                      onClick={goToLogin}
                    />
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>
    </>
  );
};
